// extracted by mini-css-extract-plugin
export var HomeContentWrapper = "index-module--HomeContentWrapper--3fa5b";
export var MainAndSideWrapper = "index-module--MainAndSideWrapper--717f3";
export var SideColumnHome = "index-module--SideColumnHome--1d195";
export var displayNone = "index-module--display-none--5f624";
export var introSection = "index-module--intro-section--31b8e";
export var main = "index-module--main--1ba09";
export var sectionWrapper = "index-module--section-wrapper--ba48f";